<template>
  <div>
    <b-loading :active.sync="isLoadingPage"></b-loading>
    <div class="level is-margin-bottom-2 is-hidden-mobile">
      <div class="level-left">
        <p class="title is-4 is-spaced has-text-weight-bold label-Left">
          {{ $t("staffList.staffViewCompany") }}: {{ startupLists.length }}
          {{
            startupLists.length > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }}
        </p>
      </div>
      <div class="level-right">
        <b-dropdown ref="dropdowntablet" position="is-bottom-left">
          <button class="button btn-Filter" slot="trigger">
            <span class="icon is-small">
              <i class="fa fa-filter"></i>
            </span>
            <span>{{ $t("message.btnFilter") }}</span>
          </button>
          <b-dropdown-item custom paddingless>
            <div class="modal-card mx-not modal-search over-filter">
              <section class="modal-card-body contentSearch">
                <div class="headerFilter">
                  <span class="icon is-small is-size-5">
                    <i class="fa fa-filter"></i>
                  </span>
                  <span
                    class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >{{ $t("message.btnFilter") }}</span
                  >
                </div>
                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    v-model="searchCompany"
                    icon="search"
                    :placeholder="$t('staffList.viewCompanyName')"
                    expanded
                  ></b-input>
                </b-field>
                <b-field grouped label>
                  <b-select
                    :placeholder="$t('staffList.viewCompanyIndustry')"
                    v-model="searchIndus"
                    expanded
                  >
                    <option
                      v-for="item in businessType"
                      :key="item.index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                    ช
                  </b-select>
                </b-field>
                <b-field grouped label>
                  <b-select
                    :placeholder="$t('staffList.viewCompanyCompanyStatus')"
                    v-model="searchCompanyStatus"
                    expanded
                  >
                    <option
                      v-for="item in statusAccount"
                      :key="item.statusId"
                      :value="item.statusId"
                    >
                      {{ item.name }}
                    </option>
                  </b-select>
                </b-field>
                <b-field grouped>
                  <b-datepicker
                    :placeholder="$t('staffList.viewCompanyContractDate')"
                    v-model="searchcontractDate"
                    icon="calendar-alt"
                    icon-pack="fas"
                    expanded
                  >
                  </b-datepicker>
                </b-field>
                <b-field grouped>
                  <div class="control is-expanded level">
                    <div class="search-btn">
                      <button @click="filter()" class="button btnSearch">
                        {{ $t("message.btnSearch") }}
                      </button>
                    </div>
                    <div class="reset-btn">
                      <button @click="resetFilter()" class="button btnReset th">
                        {{ $t("message.btnReset") }}
                      </button>
                    </div>
                  </div>
                </b-field>
              </section>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div
      class="is-flex is-justify-spacebetween is-align-center is-hidden-tablet"
    >
      <div>
        <p class="title is-size-6-5 is-spaced has-text-weight-bold label-Left">
          {{ $t("staffList.noCompany") }} {{ startupLists.length }}
          {{ $t("message.companySuffix") }}
        </p>
      </div>
      <div>
        <b-dropdown ref="dropdownmobile" position="is-bottom-left">
          <button class="button btn-Filter-mobile" slot="trigger">
            <span class="icon is-small">
              <i class="fa fa-filter"></i>
            </span>
            <span>{{ $t("message.btnFilter") }}</span>
          </button>
          <b-dropdown-item custom paddingless>
            <div class="modal-card mx-not modal-search">
              <section class="modal-card-body contentSearch">
                <div class="headerFilter">
                  <span class="icon is-small is-size-5">
                    <i class="fa fa-filter"></i>
                  </span>
                  <span
                    class="is-padding-sm-x is-size-5 has-text-weight-normal"
                    >{{ $t("message.btnFilter") }}</span
                  >
                </div>
                <b-field grouped>
                  <b-input
                    class="is-medium"
                    type="search"
                    icon-pack="fas"
                    v-model="searchCompany"
                    icon="search"
                    :placeholder="$t('staffList.viewCompanyName')"
                    expanded
                  ></b-input>
                </b-field>
                <b-field grouped label>
                  <b-select
                    :placeholder="$t('staffList.viewCompanyIndustry')"
                    v-model="searchIndus"
                    expanded
                  >
                    <option
                      v-for="item in businessType"
                      :key="item.index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-select>
                </b-field>
                <b-field grouped label>
                  <b-select
                    :placeholder="$t('staffList.viewCompanyCompanyStatus')"
                    v-model="searchCompanyStatus"
                    expanded
                  >
                    <option
                      v-for="item in statusAccount"
                      :key="item.statusId"
                      :value="item.statusId"
                    >
                      {{ item.name }}
                    </option>
                  </b-select>
                </b-field>
                <b-field grouped>
                  <b-datepicker
                    :placeholder="$t('staffList.viewCompanyContractDate')"
                    v-model="searchcontractDate"
                    icon="calendar-alt"
                    icon-pack="fas"
                    expanded
                  >
                  </b-datepicker>
                </b-field>
                <b-field grouped>
                  <div class="control is-expanded level">
                    <div class="search-btn">
                      <button @click="filter()" class="button btnSearch">
                        {{ $t("message.btnSearch") }}
                      </button>
                    </div>
                    <div class="reset-btn">
                      <button @click="resetFilter()" class="button btnReset th">
                        {{ $t("message.btnReset") }}
                      </button>
                    </div>
                  </div>
                </b-field>
              </section>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="columns is-margin-x-not head-table is-hidden-mobile">
      <div
        class="column is-3 has-text-centered"
        @click="sortBy('organizeName')"
      >
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'organizeName' }"
        >
          {{ $t("staffList.viewCompanyName") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'organizeName'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('typeOfIndustry')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'typeOfIndustry' }"
        >
          {{ $t("staffList.viewCompanyIndustry") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'typeOfIndustry'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('contractDate')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'contractDate' }"
        >
          {{ $t("staffList.viewCompanyContractDate") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'contractDate'"
          ></span>
        </p>
      </div>

      <div class="column has-text-centered" @click="sortBy('dateUpdate')">
        <p
          class="is-size-7 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'dateUpdate' }"
        >
          {{ $t("staffList.viewCompanyLastUpdated") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'dateUpdate'"
          ></span>
        </p>
      </div>
      <div class="column is-1 has-text-centered"></div>
    </div>

    <div
      v-if="startupLists.length <= 0"
      class="is-detail-list detail-table-m is-margin-bottom-m mg-y-15"
    >
      <p class="has-text-drak is-size-6 th is-padding-x">
        *** {{ $t("staffList.notFoundCompany") }} ***
      </p>
    </div>
    <div
      class="columns detail-table is-margin-x-not is-vcentered"
      v-for="(data, index) in startupLists"
      :key="index"
    >
      <div class="column has-text-right is-1 is-hidden-tablet">
        <div @click="viewAction(data.startUpId)">
          <span class="icon is-large">
            <i class="fas fa-3x fa-eye"></i>
          </span>
        </div>
      </div>

      <div class="column is-3" data-label="organizeName">
        <div
          class="is-align-center is-justify-center is-flex-large is-flex-row is-hidden-mobile"
        >
          <div class="column is-1"></div>
          <div
            class="column is-3 is-2-fullhd has-text-centered-tablet has-text-right"
          >
            <figure class="image box-circle-s is-marginless">
              <img
                class="img-rounded"
                v-if="data.organizeLogo"
                @error="
                  $event.target.src =
                    'https://bulma.io/images/placeholders/64x64.png'
                "
                :src="imgUrl + data.organizeLogo"
              />
              <img
                class="img-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column has-text-left">
            <p class="has-text-dark is-size-7 has-text-weight-normal th">
              {{ data.organizeName }}
            </p>
            <p class="is-size-7 has-text-weight-normal th">{{ data.name }}</p>
            <div
              v-if="data.statusActive == 1"
              class="textIconCompanyBox has-text-left"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-success"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusInprocess") }}
              </p>
            </div>
            <div
              v-if="data.statusActive == 2"
              class="textIconCompanyBox has-text-left"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-info"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusAchieved") }}
              </p>
            </div>
            <div
              v-if="data.statusActive == 0"
              class="textIconCompanyBox has-text-left"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-grey-light"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusAchieved") }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="is-align-center is-justify-center is-flex is-flex-column is-hidden-tablet"
        >
          <div class="column is-6 has-text-centered pd-col-fixed">
            <figure class="image box-circle-s">
              <img
                class="img-rounded"
                @error="
                  $event.target.src =
                    'https://bulma.io/images/placeholders/64x64.png'
                "
                v-if="data.organizeLogo"
                :src="imgUrl + data.organizeLogo"
              />
              <img
                class="img-rounded"
                v-else
                src="https://bulma.io/images/placeholders/64x64.png"
                alt="Placeholder image"
              />
            </figure>
          </div>
          <div class="column is-6 has-text-centered pd-col-fixed">
            <p class="has-text-dark is-size-7 has-text-weight-normal th">
              {{ data.organizeName }}
            </p>
            <p class="is-size-7 has-text-weight-normal th">{{ data.name }}</p>
          </div>
        </div>
      </div>

      <div class="column has-text-centered-mobile" data-label="typeOfIndustry">
        <p
          class="is-size-7 has-text-weight-light th"
          v-for="level in businessType"
          :key="level.index"
          :title="level.name"
        >
          <span v-if="data.typeOfBusiness == level.id">{{
            level.name | snippetSmall
          }}</span>
        </p>
      </div>

      <div class="column has-text-centered" data-label="contractDate">
        <p class="is-size-6 has-text-weight-normal">
          {{ dateFomatNotTime(data.contractDate) }}
        </p>
      </div>

      <div class="column has-text-centered" data-label="dateUpdate">
        <div class="column has-text-centered is-hidden-mobile">
          <p class="is-size-6 has-text-weight-normal">
            {{ dateFomat(data.dateUpdate) }}
          </p>
        </div>
        <div
          class="is-flex is-justify-spacebetween is-align-center is-hidden-tablet pd-20"
        >
          <div class="has-text-left">
            <p class="is-size-7 has-text-weight-normal">
              {{ dateFomat(data.dateUpdate) }}
            </p>
          </div>
          <div class="has-text-right">
            <div
              v-if="data.statusActive == 1"
              class="textIconCompanyBox has-text-right"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-success"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusInprocess") }}
              </p>
            </div>
            <div
              v-if="data.statusActive == 2"
              class="textIconCompanyBox has-text-right"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-info"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusAchieved") }}
              </p>
            </div>
            <div
              v-if="data.statusActive == 0"
              class="textIconCompanyBox has-text-right"
            >
              <b-icon
                pack="fas"
                icon="sync-alt"
                custom-class="fa-circle"
                class="has-text-grey-light"
              ></b-icon>
              <p
                class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
              >
                {{ $t("message.statusInactive") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-1 is-hidden-mobile">
        <div class="boxIconEllipsis">
          <div @click="viewAction(data.startUpId)">
            <span class="icon is-large">
              <i class="fas fa-3x fa-eye"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="isStaffModal"
      :width="640"
      @close="resetStaff(), (staffDel = [])"
      class="modal-over-unset"
    >
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div class="pd-y-10">
              <span class="is-size-5 has-text-weight-semibold">{{
                $t("message.textStaff")
              }}</span>
              <span class="th is-size-6"> ({{ $t("message.desStaff") }})</span>
            </div>
            <div class="has-text-left">
              <b-field label="" class="th">
                <b-taginput
                  v-model="staffAdd"
                  :data="staffList"
                  autocomplete
                  :open-on-focus="true"
                  field="name"
                  icon="plus"
                  icon-pack="fas"
                  :placeholder="$t('message.addStaff')"
                  @typing="getFilteredTags"
                  @add="pushAddStaff"
                  @remove="pushDelStaff"
                >
                  <template slot-scope="props">
                    <p :title="props.option.name + ' ' + props.option.surname">
                      {{ props.option.name }} {{ props.option.surname }}
                    </p>
                  </template>
                  <template slot="empty">
                    {{ $t("staffList.thereNoStaff") }}
                  </template>
                </b-taginput>
              </b-field>
            </div>
            <div class="pd-y-5">
              <b-button
                @click="(staffAdd = staffListConst), (staffDel = [])"
                type="is-success"
                size="is-small"
                icon-pack="fas"
                icon-left="check"
              >
                {{ $t("message.btnSelectAll") }}
              </b-button>
            </div>
            <div class="is-flex is-flex is-align-end is-justify-end mg-t-10">
              <button
                @click="resetStaff(), (staffDel = [])"
                class="button has-text-grey-dark has-background-grey-lighter mg-5"
                slot="trigger"
              >
                <span class="th">{{ $t("message.btnCancel") }}</span>
              </button>
              <button
                @click="saveUpdateStaff"
                class="button has-text-white is-background-primary mg-5"
                slot="trigger"
              >
                <span class="th">{{ $t("message.btnSave") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../axios.js";

export default {
  data() {
    return {
      isStaffModal: false,
      searchCompany: null,
      searchIndus: null,
      searchLevel: null,
      staffList: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      isLoadingPage: true,
      currentSort: "",
      currentSortDir: "desc",
      searchcontractDate: null,
      searchCompanyStatus: null,
      staffAdd: [],
      staffDel: [],
    };
  },
  created() {
    this.fetchStartupList();
    this.fetchstaffList();
  },
  mounted() {
    this.isLoadingPage = false;
  },
  methods: {
    getStaffInCompany(staff) {
      let text = "";
      staff.map((item, index) => {
        let comma = staff.length - 1 !== index ? ", " : "";
        text += item.staff + comma;
      });

      if (text === "") {
        return this.$i18n.locale === "th"
          ? "กรุณาเลือกผู้ดูแล"
          : "Please select staff";
      } else {
        return text;
      }
    },
    resetStaff() {
      this.$store.commit("setModalActive", false);
      this.isStaffModal = false;
      this.companyId = null;
      this.staffAdd = [];
      this.staffDel = [];
    },
    openStaffModal(id, staff) {
      this.$store.commit("setModalActive", true);
      this.isStaffModal = true;
      this.companyId = id;
      let filterStaff = [];
      staff.map((item) => {
        let resFilter = this.getStaffDetail(item.staffId);
        if (resFilter !== null) {
          filterStaff.push(resFilter);
        }
      });
      this.staffAdd = filterStaff;
    },
    getStaffDetail(value) {
      let filter = this.staffList.filter((result) =>
        result.staffId.match(value)
      );
      if (filter.length > 0) {
        return filter[0];
      } else {
        return null;
      }
    },
    sortBy(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },
    getTypeOfIndustry(id) {
      const data = this.businessType.filter((item) => item.id === id);
      let res = "";
      if (typeof data === "undefined" || data === null || data.length === 0) {
        res = "";
      } else {
        res = data[0].name;
      }
      return res;
    },
    getLevelOfBusiness(id) {
      const data = this.businessLevel.filter((item) => item.id === id);
      let res = "";
      if (typeof data === "undefined" || data === null || data.length === 0) {
        res = "";
      } else {
        res = data[0].name;
      }
      return res;
    },
    resetFilter() {
      this.$store.commit("setStartupList", this.allList);
      this.searchCompany = null;
      this.searchIndus = null;
      this.searchcontractDate = null;
      this.searchCompanyStatus = null;
    },
    filter() {
      // console.log('====================================');
      // console.log(this.allList);
      // console.log('====================================');
      var filter = this.allList.filter(
        (search) =>
          ((this.searchCompany !== null &&
            (search.name
              .toLowerCase()
              .indexOf(this.searchCompany.toLowerCase()) > -1 ||
              search.organizeName
                .toLowerCase()
                .indexOf(this.searchCompany.toLowerCase()) > -1)) ||
            this.searchCompany === null) &&
          ((search.typeOfBusiness === Number(this.searchIndus) &&
            this.searchIndus !== null) ||
            this.searchIndus === null) &&
          ((this.searchCompanyStatus !== null &&
            Number(search.statusActive) === Number(this.searchCompanyStatus)) ||
            this.searchCompanyStatus === null) &&
          ((this.searchcontractDate !== null &&
            new Date(search.contractDate).getTime() ===
              new Date(this.searchcontractDate).getTime()) ||
            this.searchcontractDate === null)
      );

      if (
        typeof this.$refs.dropdowntablet !== "undefined" &&
        typeof this.$refs.dropdownmobile !== "undefined"
      ) {
        this.$refs.dropdowntablet.isActive = false;
        this.$refs.dropdownmobile.isActive = false;
      }

      this.$store.commit("setStartupList", filter);
    },
    async viewAction(value) {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.get(
        `api/user/get/status/active/${value}/batch/${this.batch._id}`
      )
        .then((res) => {
          //console.log("api/user/get/status/active/${value}/batch/${this.batch._id}",res)
          if (res.data.success) {
            const data = {
              token: this.token,
              batchId: this.batch._id,
              startUpId: value,
              userId: value,
              status: res.data.obj.statusActive,
            };

            this.$store.dispatch("setUserdetail", data);
            this.$store.commit("startUpActivity", data);
            this.$store.commit("setstartupId", data.startUpId);
            this.$store.commit("setPageStatus", "staff");
            setTimeout(() => {
              this.$router.push("/dashboard/activities");
            }, 300);
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log(
            "api/user/get/status/active/${value}/batch/${this.batch._id}/error",
            e
          );
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    // fetchstaffList() {
    //   HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
    //   HTTP.get(`api/user/get/staff/on/batch/${this.batch._id}`)
    //     .then((res) => {
    //     //  console.log('api/user/get/status/active/${value}/batch/${this.batch._id}', res);
    //       if (res.data.success) {
    //         this.staffList = res.data.obj.staffs;
    //       } else {
    //         this.staffList = [];
    //       }
    //     }).catch((e) => {
    //       console.log('api/user/get/status/active/${value}/batch/${this.batch._id}/error', e.response);
    //        this.$buefy.dialog.alert('<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>');
    //     });
    // },
    pushAddStaff(item) {
      let filter = [];
      filter = this.staffAdd.filter(
        (filter) => filter.staffId === item.staffId
      );
      if (filter.length === 0) {
        this.staffAdd.push(item);
      }
    },
    pushDelStaff(item) {
      let filter = [];

      filter = this.staffDel.filter(
        (filter) => filter.staffId === item.staffId
      );
      if (filter.length === 0) {
        this.staffDel.push(item);
      }
    },
    async unassignStaffToCompany() {
      let data = [];
      this.staffDel.map((item) => {
        data.push({
          batchId: this.batch._id,
          staffId: item.staffId,
          startUpId: this.companyId,
        });
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/unassign/staff/from/company`, { data: data })
        .then((res) => {
          if (res.data.success) {
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log("api/unassign/staff/from/company/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
      return "Ok";
    },
    fetchstaffList() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`api/user/get/staff/on/batch/${this.batch._id}`)
        .then((res) => {
          //console.log(res)
          if (res.data.success) {
            this.staffList = res.data.obj.staffs;
            this.staffListConst = res.data.obj.staffs;
            this.isLoadingPage = false;
          } else {
            this.staffList = [];

            this.isLoadingPage = false;
          }
        })
        .catch((e) => {
          console.log("api/user/get/staff/on/batch/${this.batch._id}", e);
          setTimeout(() => {
            this.isLoadingPage = false;
          }, 500);
          alert("เครือขายไม่เสถียร กรุณาลองใหม่");
        });
    },
    getFilteredTags(text) {
      this.staffList = this.staffListConst.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0 ||
          option.surname.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0
        );
      });
    },
    async saveUpdateStaff() {
      this.isLoadingPage = true;
      await this.addStaffToCompany();
      await this.unassignStaffToCompany();
      //this.realTimeSendStartupList();
      await this.fetchStartupList();
      this.isLoadingPage = false;
      this.resetStaff();
    },

    async fetchStartupList() {
      const data = {
        token: this.token,
        staffId: this.staffDetail.staffId,
        batchId: this.batch._id,
      };
      await this.$store.dispatch("setStartupOnStaff", data);
      this.allList = this.startupLists;
    },
    dateFomatNotTime(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "-";
      } else {
        res = this.$moment(date).format("DD MMMM Y");
      }
      return res;
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = this.$moment(date).format("DD MMMM Y h:mm a");
      }
      return res;
    },
    async onSelect(staffId, startUp) {
      const data = {
        batchId: this.batch._id,
        token: this.token,
        staffId,
        startUpId: startUp,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      await HTTP.get(
        `/api/batch/${data.batchId}/staff/${data.staffId}/startUp/${data.startUpId}`,
        { showProgressBar: true }
      )
        .then((res) => {
          // console.log("/api/batch/{batchId}/staff/{staffId}/startUp/{startUpId}", res)
          if (res.data.success) {
            this.fetchStartupList();
            this.fetchstaffList();
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log(
            "/api/batch/{batchId}/staff/{staffId}/startUp/{startUpId}/error",
            e
          );
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
    },
    async addStaffToCompany() {
      let data = [];
      this.staffAdd.map((item) => {
        data.push({
          batchId: this.batch._id,
          staffId: item.staffId,
          startUpId: this.companyId,
        });
      });

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      await HTTP.post(`api/batch/assign/staff/to/company`, { data: data })
        .then((res) => {
          if (res.data.success) {
          } else {
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
            );
          }
        })
        .catch((e) => {
          console.log("api/batch/assign/staff/to/company/error", e);
          this.$buefy.dialog.alert(
            '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
          );
        });
      return "Ok";
    },
    staffName(value) {
      const name = this.staffList.filter((result) =>
        result.staffId.match(value)
      );
      if (value == "") {
        var getName = "Select Staff";
      } else {
        let i;
        for (i = 0; i < name.length; i++) {
          var getName = name[i].name;
        }
      }
      return getName;
    },
  },
  computed: {
    statusAccount() {
      return this.$store.state.statusAccount;
    },
    startupLists() {
      let startup = [];
      if (
        typeof this.$store.getters.startupLists === "undefined" ||
        this.$store.getters.startupLists === null ||
        this.$store.getters.startupLists.length === 0
      ) {
        startup = [];
      } else {
        startup = this.$store.getters.startupLists.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === "desc") modifier = -1;
          if (this.currentSort === "staffId") {
            if (this.staffName(a.staffId) < this.staffName(b.staffId)) {
              return -1 * modifier;
            }
            if (this.staffName(a.staffId) > this.staffName(b.staffId)) {
              return 1 * modifier;
            }
          } else if (this.currentSort === "typeOfIndustry") {
            if (
              this.getTypeOfIndustry(a.typeOfBusiness) <
              this.getTypeOfIndustry(b.typeOfBusiness)
            ) {
              return -1 * modifier;
            }
            if (
              this.getTypeOfIndustry(a.typeOfBusiness) >
              this.getTypeOfIndustry(b.typeOfBusiness)
            ) {
              return 1 * modifier;
            }
          } else if (this.currentSort === "levelOfBusiness") {
            if (
              this.getLevelOfBusiness(a.levelOfbusiness) <
              this.getLevelOfBusiness(b.levelOfbusiness)
            ) {
              return -1 * modifier;
            }
            if (
              this.getLevelOfBusiness(a.levelOfbusiness) >
              this.getLevelOfBusiness(b.levelOfbusiness)
            ) {
              return 1 * modifier;
            }
          } else {
            if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          }
          return 0;
        });
      }
      return startup;
    },
    staffDetail() {
      return this.$store.state.staffDetail;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
    businessLevel() {
      return this.$store.state.businessLevel;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    user() {
      return this.$store.state.user;
    },
    batch() {
      return this.$store.state.batch;
    },
    getRule() {
      return this.$store.state.rule;
    },
    token() {
      return this.$store.state.token;
    },
  },
};
</script>
<style>
@media screen and (max-width: 1280px) {
  .figureless {
    margin-left: 0.2rem !important;
  }
}
@media screen and (min-width: 1280px) {
  .figureless {
    margin-left: 1.5rem !important;
  }
}
.imgStaff {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  margin-right: 1.5rem;
  margin-left: 1rem;
}
.boxStaffData {
  margin-top: 2.5rem;
}
.textPersonal {
  color: #3eb3b4;
}
#hideTitle {
  visibility: hidden;
}
</style>

